import axios from "axios";
import Cookies from "js-cookie";
export default {
    props: ['datas'],
    data() {
        return {
            infoForm: {
                Url: '',
                Header: 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            formValidate: {

            },
            value1: '',
            fieldsList: [],
            operatorList: [
                {
                    value: ' = ',
                    name: '等于'
                },
                {
                    value: ' > ',
                    name: '大于'
                },
                {
                    value: ' < ',
                    name: '小于'
                },
                {
                    value: ' != ',
                    name: '不等于'
                },
            ],
            conditionVal: '',
            resColumns: [],
            resTablesList: [],
        }
    },
    mounted() {
        this.infoForm.Url = this.datas.urlL;
        //取出输出字段
        let arr = JSON.parse(this.datas.outOrinFields);
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].inputisselected == true) {
                this.fieldsList.push(arr[i]);
            }
        }
    },
    methods: {
        //发送请求
        sendAjax() {
            console.log(this.fieldsList);
            var params = {
                json: '',
            }
            var data = {
                condition: JSON.stringify(this.fieldsList)
            };
            params.json = JSON.stringify(data);
            let that = this;
            $.ajax({
                type: "post",
                url: '/api/' + this.datas.url,
                async: true,
                dataType: "json",
                crossDomain: true,
                headers: {
                    accessToken: Cookies.get("accessToken"),
                },
                // contentType: 'application/json',
                contentType: this.infoForm.Header,
                data: params,
                success: function (res) {
                    if (res.code == 200) {
                        that.resColumns = [];
                        //动态生成表头
                        if (res.result.length > 0) {
                            that.resTablesList = res.result;
                            for (let key in res.result[0]) {
                                let obj = {
                                    title: '',
                                    key: '',
                                    align: 'center',
                                    tooltip: true,
                                    ellipsis: true,
                                    width:100
                                };
                                obj.title = key;
                                obj.key = key;
                                that.resColumns.push(obj);
                            }
                        }

                    }
                },
                error: function (res) {
                    console.log(res);
                },
            });
        },
        //清空参数
        handleSubmitForProperty() {
            for (var i = 0; i < this.fieldsList.length; i++) {
                this.fieldsList[i].value = '';
            }
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/leftmenu/layers/detail.js